import React from "react";
import ViewProfile from "./index";
import { ViewProfileHandlerProps } from "./types";

export default function ViewProfileHandler(props: ViewProfileHandlerProps) {
  const [showProfile, setShowProfile] = React.useState(false);

  const openDisplayProfileHandler = React.useCallback(() => {
    setShowProfile(true);
  }, []);

  const closeDisplayProfileHandler = React.useCallback(() => {
    setShowProfile(false);
  }, []);

  return (
    <React.Fragment>
      <span className={props.className} onClick={openDisplayProfileHandler}>
        {props.children}
      </span>
      {showProfile && (
        <ViewProfile
          contextEntityType={props.contextEntityType}
          entityId={props.contextEntityId}
          viewerProgramParticipantId={props.viewerProgramParticipantId}
          viewerEventParticipantId={props.viewerEventParticipantId}
          closeHandler={closeDisplayProfileHandler}
          eventOrganizationViewType={props.eventOrganizationViewType}
          customApi={props.customApi}
          logEvent={props.logEvent}
        />
      )}
    </React.Fragment>
  );
}
